export const funnelTooltip =
  "El objetivo de esta sección es actualizar la etapa de compra en la que se encuentran tus clientes.";

export const analyticsTooltip =
  "El objetivo de esta sección es brindar un resumen en tiempo real de lo que está sucediendo en la operación de tu negocio.";

export const media =
  "Esta métrica muestra el tiempo promedio que tarda el equipo en responder a un nuevo contacto.";

export const responseTime =
  "Esta métrica muestra el tiempo promedio que un cliente espera una respuesta.";

export const newConversations =
  "Esta métrica muestra las conversaciones creadas durante el período de tiempo elegido.";

export const allContacts =
  "Esta métrica muestra con cuántos contactos se interactuó durante el período de tiempo elegido.";

export const newContacts =
  "Esta métrica muestra el total de contactos que se han creado durante el período de tiempo elegido.";

export const featuredAgent =
  "Esta métrica muestra el agente que atendió más clientes durante el período de tiempo elegido.";

export const bestDay =
  "Esta métrica muestra el día en el que se atendió a más clientes durante el período de tiempo elegido.";
